import React from 'react';
import PropTypes from 'prop-types';
import { FDEmptyState, FDSecondaryActionButton } from '@facet-wealth/design';

const InstitutionNotFound = ({
  onClickManualInstitutionAdd,
  manualInstitutionAddPrompt,
  manualInstitutionAddDescription,
}) => {
  return (
    <FDEmptyState title={manualInstitutionAddDescription} icon="search">
      {onClickManualInstitutionAdd && <FDSecondaryActionButton
        label={manualInstitutionAddPrompt}
        data-test="add-manual-institution"
        onClick={onClickManualInstitutionAdd}
        size="sm"
        icon="add"
      />}
    </FDEmptyState>
  );
};

InstitutionNotFound.defaultProps = {
  onClickManualInstitutionAdd: null,
  manualInstitutionAddPrompt: 'Manually add your institution',
  manualInstitutionAddDescription: "We couldn't find that institution.",
};

InstitutionNotFound.propTypes = {
  onClickManualInstitutionAdd: PropTypes.func,
  manualInstitutionAddPrompt: PropTypes.string,
  manualInstitutionAddDescription: PropTypes.string,
};

export default InstitutionNotFound;
